import Controller from '@ember/controller';

import { set } from '@ember/object';
import { inject as iService } from '@ember/service';
import { task } from 'ember-concurrency';

import getConfig from 'beebee-base/lib/get-config';
import { beebeeAjaxGet, beebeeAjaxPost } from 'beebee-base/lib/utility';
export default class ConfirmController extends Controller {
  @iService session;
  @iService notify;
  @iService intl;
  @iService log;

  queryParams = ['event_id'];
  notFound = false;

  @(task(function* () {
    try {
      const event = yield beebeeAjaxGet(
        `${getConfig(this).APP.urlApi}/confirm_event`,
        this.session.token,
        {
          event_id: this.event_id,
        }
      );

      set(this, 'actionDone', null);

      if (event && event.information) {
        set(this, 'notFound', false);
        set(this, 'information', event.information);
      } else {
        set(this, 'notFound', true);
      }
    } catch (e) {
      set(this, 'actionDone', null);
      set(this, 'notFound', true);
    }
  }).drop())
  loadDataTask;

  @(task(function* (action = false) {
    try {
      yield beebeeAjaxPost(`${getConfig(this).APP.urlApi}/confirm_event`, this.session.token, {
        event_id: this.event_id,
        action: action,
      });

      set(this, 'actionDone', {
        action: action,
      });
    } catch (e) {
      // Left uncaught, a 4xx/network failure here surfaced as a Sentry
      // unhandled rejection. User-triggered (confirm/decline event): notify.
      this.log.error('sendAnswer failed', e);
      const detail = e?.responseJSON?.errors?.[0]?.detail;
      this.notify.error(detail || this.intl.t('beebeeboard error'));
      return;
    }
  }).drop())
  sendAnswer;
}
